import axios from 'axios';
import {backendHost} from '../../../../store/config';

export const postCreateCurrency = (params) => {
    return axios.post(`${backendHost}/api/admin/currency`, params);
};
